class Hamburger {
	constructor(el,opt){
		this.el = el;
		this.event();
	}
	event(){
		if(document.querySelector(".header-hum")) {
			const humBtn = document.querySelector(".header-hum");
			const menu = document.querySelector(".menu");
			humBtn.addEventListener("click", () => {
				menu.classList.toggle("is-active");
				humBtn.classList.toggle("is-active");
			});
		}
	}
}

